export function getDateTimeFieldErrors(value: string) {
  const [date, time] = value?.split(' ') ?? [];

  const { YEAR, MONTH, DAY } = deserializeDate(date);
  const incompleteTime = isIncompleteTime(time);

  const isValidYear = YEAR && isNum(YEAR);
  const isValidMonth = MONTH && isNum(MONTH);
  const isValidDay = DAY && isNum(DAY);

  if (!incompleteTime && isValidYear && isValidMonth && isValidDay) {
    return;
  }

  return {
    TIME: incompleteTime,
    YEAR: !isValidYear,
    MOTH: !isValidMonth,
    DAY: !isValidDay,
  };
}

function isNum(val: string) {
  return /^\d+$/.test(val);
}

export enum SupportedDateParts {
  DAY = 'DAY',
  MONTH = 'MONTH',
  YEAR = 'YEAR',
}

export type DateFieldValue = {
  [SupportedDateParts.DAY]?: string;
  [SupportedDateParts.MONTH]?: string;
  [SupportedDateParts.YEAR]?: string;
};

export type DateFieldError = {
  [SupportedDateParts.DAY]?: boolean;
  [SupportedDateParts.MONTH]?: boolean;
  [SupportedDateParts.YEAR]?: boolean;
};

export const deserializeDate = (value?: string): DateFieldValue => {
  if (!value) {
    return {
      [SupportedDateParts.YEAR]: '',
      [SupportedDateParts.MONTH]: '',
      [SupportedDateParts.DAY]: '',
    };
  }

  const [year, month, day] = value.split('-');

  return {
    [SupportedDateParts.YEAR]: year,
    [SupportedDateParts.MONTH]: month ? String(parseInt(month, 10)) : '',
    [SupportedDateParts.DAY]: day ? String(parseInt(day, 10)) : '',
  };
};

export const isIncompleteTime = (time?: string) => {
  if (!time) {
    return true;
  }
  const [hours, minutes] = time.split(':');
  return !hours || !minutes;
};
